import { parseMapLocation } from "../pages/dashboard/mapLocation";
import { isOldProfileWithoutDogImages } from "../models/mapProfileVisibility";
import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import {
  Check,
  Bone,
  Heart,
  ChevronDown,
  ChevronUp,
  MapPin,
  X,
  Info,
} from "lucide-react";
import sliderDogHead from "../assets/dogHead.png";
import appIcon from "../assets/socialPawsLogo.svg";
import apiClient from "../api/apiClient";
import { ENDPOINTS } from "../api/endPoints";

const BREED_LIST = [
  "Affenpinscher",
  "Afghan Hound",
  "Airedale Terrier",
  "Akita",
  "Alaskan Malamute",
  "American Bulldog",
  "American Eskimo Dog",
  "American Foxhound",
  "American Pit Bull Terrier",
  "American Staffordshire Terrier",
  "Australian Cattle Dog",
  "Australian Shepherd",
  "Australian Terrier",
  "Aussiedoodle",
  "Basenji",
  "Basset Hound",
  "Beagle",
  "Bearded Collie",
  "Bedlington Terrier",
  "Belgian Malinois",
  "Belgian Sheepdog",
  "Belgian Tervuren",
  "Bernedoodle",
  "Mini Bernedoodle",
  "Bernese Mountain Dog",
  "Bichon Frise",
  "Black and Tan Coonhound",
  "Bloodhound",
  "Border Collie",
  "Border Terrier",
  "Borzoi",
  "Boston Terrier",
  "Bouvier des Flandres",
  "Boxer",
  "Boykin Spaniel",
  "Briard",
  "Brittany",
  "Brussels Griffon",
  "Bull Terrier",
  "Bulldog (English)",
  "Bullmastiff",
  "Cairn Terrier",
  "Canaan Dog",
  "Cane Corso",
  "Cardigan Welsh Corgi",
  "Cavalier King Charles Spaniel",
  "Cavapoo",
  "Chesapeake Bay Retriever",
  "Chiweenie",
  "Chihuahua",
  "Chinese Crested",
  "Chow Chow",
  "Clumber Spaniel",
  "Cockapoo",
  "Cocker Spaniel",
  "Collie",
  "Coton de Tulear",
  "Curly-Coated Retriever",
  "Dachshund",
  "Mini Dachshund",
  "Long-Haired Dachshund",
  "Wire-Haired Dachshund",
  "Dalmatian",
  "Dandie Dinmont Terrier",
  "Doberman Pinscher",
  "Dogo Argentino",
  "Dutch Shepherd",
  "English Setter",
  "English Springer Spaniel",
  "English Toy Spaniel",
  "Field Spaniel",
  "Finnish Spitz",
  "Flat-Coated Retriever",
  "French Bulldog",
  "German Pinscher",
  "German Shepherd",
  "German Shorthaired Pointer",
  "German Wirehaired Pointer",
  "Giant Schnauzer",
  "Glen of Imaal Terrier",
  "Golden Retriever",
  "Goldendoodle",
  "Mini Goldendoodle",
  "Gordon Setter",
  "Great Dane",
  "Great Pyrenees",
  "Greater Swiss Mountain Dog",
  "Greyhound",
  "Havanese",
  "Ibizan Hound",
  "Icelandic Sheepdog",
  "Irish Setter",
  "Irish Terrier",
  "Irish Water Spaniel",
  "Irish Wolfhound",
  "Italian Greyhound",
  "Jack Russell Terrier",
  "Japanese Chin",
  "Keeshond",
  "Kerry Blue Terrier",
  "Komondor",
  "Kuvasz",
  "Labrador Retriever",
  "Labradoodle",
  "Mini Labradoodle",
  "Lagotto Romagnolo",
  "Lakeland Terrier",
  "Leonberger",
  "Lhasa Apso",
  "Lowchen",
  "Maltese",
  "Maltipoo",
  "Manchester Terrier",
  "Mastiff",
  "Mini American Shepherd (Mini Aussie)",
  "Miniature Bull Terrier",
  "Miniature Pinscher",
  "Miniature Schnauzer",
  "Mini Poodle",
  "Morkie",
  "Neapolitan Mastiff",
  "Newfoundland",
  "Norfolk Terrier",
  "Norwegian Elkhound",
  "Norwich Terrier",
  "Old English Sheepdog",
  "Other",
  "Otterhound",
  "Papillon",
  "Parson Russell Terrier",
  "Pekingese",
  "Pembroke Welsh Corgi",
  "Petit Basset Griffon Vendéen",
  "Pharaoh Hound",
  "Plott Hound",
  "Pointer",
  "Pomsky",
  "Pomeranian",
  "Portuguese Water Dog",
  "Poodle (Standard)",
  "Poodle (Toy)",
  "Pug",
  "Puggle",
  "Puli",
  "Pyrenean Shepherd",
  "Rat Terrier",
  "Redbone Coonhound",
  "Rescue / Unknown",
  "Rhodesian Ridgeback",
  "Rottweiler",
  "Saint Bernard",
  "Saluki",
  "Samoyed",
  "Schipperke",
  "Schnoodle",
  "Scottish Deerhound",
  "Scottish Terrier",
  "Sealyham Terrier",
  "Shar-Pei",
  "Shetland Sheepdog",
  "Sheepadoodle",
  "Shiba Inu",
  "Shih Tzu",
  "Shorkie",
  "Siberian Husky",
  "Silky Terrier",
  "Skye Terrier",
  "Sloughi",
  "Smooth Fox Terrier",
  "Soft Coated Wheaten Terrier",
  "Spinone Italiano",
  "Staffordshire Bull Terrier",
  "Standard Schnauzer",
  "Sussex Spaniel",
  "Swedish Vallhund",
  "Tibetan Mastiff",
  "Tibetan Spaniel",
  "Tibetan Terrier",
  "Toy Fox Terrier",
  "Vizsla",
  "Weimaraner",
  "Welsh Springer Spaniel",
  "Welsh Terrier",
  "West Highland White Terrier",
  "Whippet",
  "Wire Fox Terrier",
  "Wirehaired Pointing Griffon",
  "Xoloitzcuintli",
  "Yorkipoo",
  "Yorkshire Terrier",
  "Mixed Breed",
];

const FilterPanel = ({
  isOpen,
  onClose,
  filterData,
  setFilterData,
  onApplyFilters,
  onClear,
  profile,
  userLocation,
  locationSource = "current",
}) => {
  const sliderRef = useRef(null);
  const isDraggingRef = useRef(false);

  const [searchInput, setSearchInput] = useState(() => {
    return sessionStorage.getItem("social_paws_searchInput") || "";
  });

  const [tempValue, setTempValue] = useState(filterData.proximityValue);

  const [breedSearch, setBreedSearch] = useState("");
  const [isBreedDropdownOpen, setIsBreedDropdownOpen] = useState(false);

  const isPupPal =
    profile?.user_dog_status === 0 || profile?.user_dog_status === "0" ||
    (profile?.team_social === 1 && profile?.team_paws !== 1);
  const { availability, breed, experience } = filterData;
  const teamSelection = isPupPal ? "paws" : filterData.teamSelection;

  useEffect(() => {
    if (isPupPal && filterData.teamSelection !== "paws") {
      setFilterData((prev) => ({ ...prev, teamSelection: "paws" }));
    }
  }, [isPupPal, filterData.teamSelection, setFilterData]);
  const selectedAges = (filterData.age || "").split(",").filter((age) => ["Puppy", "Adult", "Senior"].includes(age));

  useEffect(() => {
    sessionStorage.setItem("social_paws_searchInput", searchInput);
  }, [searchInput]);

  useEffect(() => {
    setTempValue(filterData.proximityValue);
  }, [filterData.proximityValue]);

  // Filter Logic Constants
  const TRACK_START = 5;
  const TRACK_END = 95;
  const TRACK_RANGE = TRACK_END - TRACK_START;
  const PROXIMITY_STEPS = 5;

  // Breed Logic
  const filteredBreeds = useMemo(() => {
    return BREED_LIST.filter((b) =>
      b.toLowerCase().includes(breedSearch.toLowerCase()),
    );
  }, [breedSearch]);

  useEffect(() => {
    if (filterData.breed === "") {
      setBreedSearch("");
    }
  }, [filterData.breed]);

  const handleTeamSelection = (selection) => {
    if (isPupPal) return;
    setFilterData((prev) => {
      const current = prev.teamSelection || "both";

      if (current === "both") {
        return {
          ...prev,
          teamSelection: selection === "paws" ? "social" : "paws",
        };
      } else if (current !== selection) {
        return { ...prev, teamSelection: "both" };
      }
      return prev;
    });
  };

  const handleBreedSelect = (selectedBreed) => {
    setFilterData((prev) => ({ ...prev, breed: selectedBreed }));
    setBreedSearch("");
    setIsBreedDropdownOpen(false);
  };

  const toggleAvailability = (option) => {
    let lowerOption = option.toLowerCase();
    if (lowerOption === "holidays") {
      lowerOption = "vacations";
    }

    setFilterData((prev) => ({
      ...prev,
      availability: prev.availability.includes(lowerOption)
        ? prev.availability.filter((item) => item !== lowerOption)
        : [...prev.availability, lowerOption],
    }));
  };

  const toggleExperience = (option) => {
    const lowerOption = option.toLowerCase();
    setFilterData((prev) => ({
      ...prev,
      experience: prev.experience === lowerOption ? "" : lowerOption,
    }));
  };

  // Slider Logic
  const updateStep = (clientX) => {
    if (!sliderRef.current) return;
    const rect = sliderRef.current.getBoundingClientRect();
    let percent = (clientX - rect.left) / rect.width;
    percent = Math.max(0, Math.min(1, percent));
    const step = Math.round(percent * PROXIMITY_STEPS);
    setTempValue(step);
  };

  const handlePointerDown = (e) => {
    isDraggingRef.current = true;
    updateStep(e.clientX || e.touches?.[0]?.clientX);
  };

  const handlePointerMove = useCallback((e) => {
    if (!isDraggingRef.current) return;
    if (e.cancelable) e.preventDefault();
    updateStep(e.clientX || e.touches?.[0]?.clientX);
  }, []);

  const handlePointerUp = useCallback(() => {
    if (isDraggingRef.current) {
      isDraggingRef.current = false;
      setFilterData((prev) => ({ ...prev, proximityValue: tempValue }));
    }
  }, [tempValue, setFilterData]);

  useEffect(() => {
    window.addEventListener("mousemove", handlePointerMove);
    window.addEventListener("mouseup", handlePointerUp);
    window.addEventListener("touchmove", handlePointerMove, { passive: false });
    window.addEventListener("touchend", handlePointerUp);
    return () => {
      window.removeEventListener("mousemove", handlePointerMove);
      window.removeEventListener("mouseup", handlePointerUp);
      window.removeEventListener("touchmove", handlePointerMove);
      window.removeEventListener("touchend", handlePointerUp);
    };
  }, [handlePointerMove, handlePointerUp]);

  const fillWidth = TRACK_START + (tempValue / PROXIMITY_STEPS) * TRACK_RANGE;

  const [filteredResults, setFilteredResults] = useState([]);
  const [isFiltering, setIsFiltering] = useState(false);
  const [filterError, setFilterError] = useState("");
  const filterRequestRef = useRef(0);

  const availabilityDeps = useMemo(() => {
    return (filterData.availability || []).slice().sort().join(",");
  }, [filterData.availability]);

  const validLocation = parseMapLocation(userLocation?.lat, userLocation?.lng);
  const roundedLat = validLocation ? validLocation.lat.toFixed(4) : null;
  const roundedLng = validLocation ? validLocation.lng.toFixed(4) : null;

  useEffect(() => {
    const requestId = ++filterRequestRef.current;
    const controller = new AbortController();
    setFilteredResults([]);
    setFilterError("");
    if (!roundedLat || !roundedLng) {
      setIsFiltering(false);
      return;
    }
    setIsFiltering(true);
    const delayDebounceFn = setTimeout(() => {
      fetchFilteredDogs(requestId, controller.signal);
    }, 500);

    return () => {
      clearTimeout(delayDebounceFn);
      controller.abort();
      filterRequestRef.current += 1;
    };
  }, [
    roundedLat,
    roundedLng,
    profile?.id,
    isOpen,
    searchInput,
    filterData.teamSelection,
    availabilityDeps,
    filterData.breed,
    filterData.experience,
    filterData.age,
    filterData.proximityValue,
  ]);

  const fetchFilteredDogs = useCallback(async (requestId, signal) => {
    if (!userLocation) {
      setIsFiltering(false);
      return;
    }

    setIsFiltering(true);
    try {
      const currentLat = userLocation.lat;
      const currentLng = userLocation.lng;

      const userId = profile?.id || "";

      const params = new URLSearchParams({
        currentLat,
        currentLng,
        userId,
      });

      if (teamSelection && teamSelection !== "both") {
        params.append("team_paws", teamSelection === "paws");
        params.append("team_social", teamSelection === "social");
      }

      const availabilityString = filterData.availability
        .filter((item) => item && item.trim() !== "")
        .join(",");

      params.append("availability", availabilityString);

      if (filterData.experience) {
        params.append("dog_activity", filterData.experience);
      }

      const ageGroup = (filterData.age || "").split(",").filter((age) => ["Puppy", "Adult", "Senior"].includes(age)).join(",");
      if (ageGroup) params.append("age_group", ageGroup);

      params.append("search", searchInput);
      params.append("breed", filterData.breed || "");

      const initialSliderValue = 5;
      if (filterData.proximityValue !== initialSliderValue) {
        params.append("range_miles", filterData.proximityValue + 1);
      }

      const response = await apiClient.get(
        `${ENDPOINTS.GET_WEBAPP_FILTERS}?${params.toString()}`,
        { signal },
      );
      if (signal.aborted || requestId !== filterRequestRef.current) return;
      if (!response.data?.success) throw new Error("Filter request failed");

      if (response.data?.success) {
        let fetchedData = response.data.data || [];

        // Filter out dogs with missing, empty, or 0 coordinates
        fetchedData = fetchedData.filter((dog) => {
          if (isOldProfileWithoutDogImages(dog)) return false;
          if (dog.is_old_user === 1 || dog.is_old_user === true) {
            if (
              dog.isDogProfileComplete !== 1 &&
              dog.isDogProfileComplete !== true &&
              dog.isDogProfileHalfComplete !== 1 &&
              dog.isDogProfileHalfComplete !== true
            ) {
              return false;
            }
          }

          if (String(dog.user_id) === String(userId)) return false;

          const lat = dog.user_latitude;
          const lng = dog.user_longitude;

          // Exclude null, undefined, or empty strings
          if (lat == null || lat === "" || lng == null || lng === "")
            return false;

          const numLat = parseFloat(lat);
          const numLng = parseFloat(lng);

          // Exclude coordinates that parse to exactly 0 or are Not-a-Number
          if (isNaN(numLat) || numLat === 0 || isNaN(numLng) || numLng === 0) {
            return false;
          }

          return true;
        });

        // Check if the currently logged-in user is a Pup Pal
        const isLoggedPupParent =
          profile?.team_paws === 1 || profile?.user_dog_status === 1;

        const isLoggedPupPal =
          (profile?.team_social === 1 && profile?.team_paws !== 1) ||
          profile?.user_dog_status === 0;

        // If the logged user is a Pup Pal (and not a Pup Parent), restrict results to Pup Parents only
        if (!isLoggedPupParent && isLoggedPupPal) {
          fetchedData = fetchedData.filter(
            (dog) => dog.team_paws === 1 || dog.user_dog_status === 1,
          );
        }

        setFilteredResults(fetchedData);
      }
    } catch (error) {
      if (!signal.aborted && requestId === filterRequestRef.current) {
        setFilteredResults([]);
        setFilterError("Could not load matching profiles. Change a filter or reopen the filters to try again.");
      }
    } finally {
      if (!signal.aborted && requestId === filterRequestRef.current) setIsFiltering(false);
    }
  }, [filterData, searchInput, profile, userLocation, teamSelection]);

  return (
    <>
      <div className={`filter-panel ${isOpen ? "open" : ""}`}>
        <div className="filter-appicon filter-desktop-only">
          <img
            src={appIcon}
            alt="Social Paws"
            style={{ width: "28px", height: "28px", objectFit: "contain" }}
          />
          <span
            style={{
              color: "rgba(0, 155, 206, 1)",
              fontSize: "18px",
              fontWeight: "700",
              padding: "6px",
            }}
          >
            Social Paws
          </span>
        </div>
        <button
          className="filter-close-btn"
          onClick={() => {
            setIsBreedDropdownOpen(false);
            onClose();
          }}
        >
          <X className="filter-close-icon" strokeWidth={3} />
        </button>
        <div className="filter-content">
          <div className="filter-header">
            <h2>Filters</h2>
          </div>

          <div className="filter-section">
            <div className="filter-label-row">
              <label className="filter-label">SEARCH</label>

              <div className="info-wrapper">
                <Info size={18} strokeWidth={3} className="filter-info-icon" />

                <div className="tooltip">
                  Find a specific profile by entering a name, browse profiles in
                  another location by entering a different address.
                </div>
              </div>
            </div>

            <input
              type="text"
              placeholder="Search by Name or Location"
              className="filter-text-input"
              value={searchInput}
              onChange={(e) => setSearchInput(e.target.value)}
            />
          </div>

          <div className="filter-section">
            <label className="filter-label">TEAM</label>
            <div className="team-toggle-group">
              <button
                className={`team-toggle-btn ${
                  teamSelection === "paws" ||
                  teamSelection === "both" ||
                  !teamSelection
                    ? "active-paws"
                    : ""
                }`}
                onClick={() => handleTeamSelection("paws")}
              >
                {(teamSelection === "paws" ||
                  teamSelection === "both" ||
                  !teamSelection) && (
                  <Check
                    size={20}
                    strokeWidth={3}
                    className="filter-check-icon"
                  />
                )}
                Pups{" "}
                <Bone
                  className="filter-bone-icon"
                  style={{ transform: "rotate(45deg)" }}
                  fill="rgba(164, 217, 235, 1)"
                  stroke="none"
                />
              </button>
              {!isPupPal && <button
                className={`team-toggle-btn ${
                  teamSelection === "social" ||
                  teamSelection === "both" ||
                  !teamSelection
                    ? "active-social"
                    : ""
                }`}
                onClick={() => handleTeamSelection("social")}
              >
                {(teamSelection === "social" ||
                  teamSelection === "both" ||
                  !teamSelection) && (
                  <Check
                    size={20}
                    strokeWidth={3}
                    className="filter-check-icon"
                  />
                )}
                Pup Pals{" "}
                <Heart
                  className="filter-heart-icon"
                  fill="rgba(71, 215, 172, 1)"
                  stroke="none"
                />
              </button>}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">PROXIMITY</label>
            <div className="proximity-options">
              <div className="proximity-radio">
                <MapPin size={18} className="filter-pin-icon" />
                <span className="filter-pin-text">
                  Search point—from your {locationSource === "profile" ? "saved profile location" : "current location"}
                </span>
                <p>
                  {tempValue === PROXIMITY_STEPS
                    ? "All"
                    : `${tempValue + 1} Blocks`}
                </p>
              </div>
            </div>

            <div
              className="filter-slider-container"
              ref={sliderRef}
              onMouseDown={handlePointerDown}
              onTouchStart={handlePointerDown}
              style={{
                cursor: "pointer",
                touchAction: "none",
                userSelect: "none",
              }}
            >
              <div className="filter-slider-track-bg" />

              <div
                className="filter-slider-track-fill"
                style={{ width: `${fillWidth}%` }}
              />

              {[0, 1, 2, 3, 4, 5].map((step) => (
                <div
                  key={step}
                  className="filter-slider-dot"
                  style={{
                    left: `${TRACK_START + (step / PROXIMITY_STEPS) * TRACK_RANGE}%`,
                  }}
                />
              ))}

              <div
                className="filter-slider-thumb"
                style={{
                  left: `${fillWidth}%`,
                  position: "absolute",
                  transform: "translate(-50%, -50%)",
                  pointerEvents: "none",
                }}
              >
                <img
                  src={sliderDogHead}
                  alt="Slider Dog"
                  style={{ display: "block" }}
                />
              </div>
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">AVAILABILITY</label>
            <div className="availability-grid">
              {[
                "Weekdays",
                "Weekends",
                "Holidays",
                "Mornings",
                "Afternoons",
                "Evenings",
              ].map((opt) => {
                let valueToCheck = opt.toLowerCase();
                if (valueToCheck === "holidays") {
                  valueToCheck = "vacations";
                }
                const isActive = availability.includes(valueToCheck);

                return (
                  <button
                    key={opt}
                    className={`availability-btn ${isActive ? "active" : ""}`}
                    onClick={() => toggleAvailability(opt)}
                  >
                    {isActive && (
                      <Check
                        size={16}
                        strokeWidth={3}
                        className="filter-check-small"
                      />
                    )}{" "}
                    {opt}
                  </button>
                );
              })}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">EXPERIENCE</label>
            <div className="experience-grid">
              {["Exercise", "Companionship", "Both"].map((opt) => {
                const lowerOpt = opt.toLowerCase();
                const isChecked = filterData.experience === lowerOpt;

                return (
                  <button
                    key={opt}
                    className={`experience-btn ${isChecked ? "active" : ""}`}
                    onClick={() => toggleExperience(opt)}
                  >
                    <span>{opt}</span>
                  </button>
                );
              })}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">AGE</label>
            <div className="experience-grid" role="group" aria-label="Age">
              {["Puppy", "Adult", "Senior"].map((age) => (
                <button
                  type="button"
                  key={age}
                  className={`experience-btn ${selectedAges.includes(age) ? "active" : ""}`}
                  aria-pressed={selectedAges.includes(age)}
                  onClick={() => setFilterData((previous) => {
                    const ages = (previous.age || "").split(",").filter((age) => ["Puppy", "Adult", "Senior"].includes(age));
                    return {
                      ...previous,
                      age: (ages.includes(age) ? ages.filter((value) => value !== age) : [...ages, age]).join(","),
                    };
                  })}
                >
                  <span>{age}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="filter-section">
            <label className="filter-label">BREED</label>
            <div className="filter-breed-dropdown-wrapper">
              <div
                className={`filter-breed-trigger ${isBreedDropdownOpen ? "open" : ""}`}
              >
                <div className="filter-breed-input-wrapper">
                  {breed && !breedSearch && (
                    <div className="filter-breed-selected-badge">
                      <span className="filter-breed-selected-text">
                        {breed}
                      </span>
                      <X
                        size={20}
                        className="filter-clear-breed-icon"
                        onClick={(e) => {
                          e.stopPropagation();
                          setFilterData((prev) => ({ ...prev, breed: "" }));
                          setBreedSearch("");
                        }}
                      />
                    </div>
                  )}
                  <input
                    type="text"
                    className="filter-breed-search-input"
                    placeholder={breed ? "" : "Type or choose breed"}
                    value={breedSearch}
                    onChange={(e) => setBreedSearch(e.target.value)}
                    onClick={() => setIsBreedDropdownOpen(true)}
                  />
                </div>

                {isBreedDropdownOpen ? (
                  <ChevronUp
                    size={20}
                    className="filter-chevron"
                    onClick={() => setIsBreedDropdownOpen(false)}
                  />
                ) : (
                  <ChevronDown
                    size={20}
                    className="filter-chevron"
                    onClick={() => setIsBreedDropdownOpen(true)}
                  />
                )}
              </div>

              {isBreedDropdownOpen && (
                <div className="filter-breed-menu">
                  {filteredBreeds.map((b, i) => (
                    <div
                      key={i}
                      className="filter-breed-option"
                      onClick={() => handleBreedSelect(b)}
                    >
                      {b}
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>

          {filterError && <p role="alert">{filterError}</p>}
          {!validLocation && <p role="status">Enable location or add a valid location to your profile to search nearby.</p>}
          <div className="filter-footer-btns">
            <button
              className="filter-reset-btn"
              onClick={() => {
                onClear();
                setBreedSearch("");
                setSearchInput("");
                sessionStorage.removeItem("social_paws_searchInput");
                setIsBreedDropdownOpen(false);
              }}
            >
              Reset
            </button>
            <button
              className="filter-sniff-btn"
              disabled={isFiltering || filteredResults.length === 0}
              onClick={() => {
                onApplyFilters(filteredResults, { search: searchInput.trim() });
                onClose();
              }}
            >
              {isFiltering
                ? "Searching..."
                : `SNIFF ${filteredResults.length} RESULTS`}
            </button>
          </div>
        </div>
      </div>
      {isOpen && (
        <div
          className="filter-overlay-bg"
          onClick={() => {
            setIsBreedDropdownOpen(false);
            onClose();
          }}
        ></div>
      )}
    </>
  );
};

export default FilterPanel;
